module.exports = __webpack_public_path__ + "img/TAMPAK BELAKANG.b51f61f6.jpg";